import React, { useContext } from 'react';
import { IListItemLinkProps } from '../../../../Components/ListItemLink/ListItemLink';
import { Sidebar, ISidebarProps } from '../../../../Components/Sidebar/Sidebar';
import {
  Dashboard,
  Gavel,
  FormatListBulleted,
  // BarChart,
   Settings,
  // LibraryAddCheck,
  DoneAll,
  // PlaylistAddCheck,
  LiveHelp,
  SupervisedUserCircle,
  BarChart
} from '@material-ui/icons';
import { useIntl } from 'react-intl';
import { AccessLevel, LawPortalFeature, Module, OrganizationFeature, UserContext } from '../../../../Context/UserContext/UserContext';


export const LawPortalSidebar = (props: ISidebarProps) => {
  const { hasAccessToFeature, hasAccessToModule, customerFeatures, applicationVersion } = useContext(UserContext);
  const accessToOurLaws = hasAccessToFeature(LawPortalFeature.OurLaws, AccessLevel.Read);
  const accessToOtherRequirements = hasAccessToFeature(LawPortalFeature.OtherRequirements, AccessLevel.Read);
  const { formatMessage } = useIntl();
  const isOldVersion = applicationVersion?.value === 1;
  const hasAvvikelserLight = customerFeatures?.some((feature: any) => feature.value === 13);
  const menuKeySuffix = isOldVersion ? '.lek.old' : '.lek';
  const hasComplianceAdminAccess = hasAccessToModule(Module.Administration) || hasAccessToModule(Module.Organization);

  const items: IListItemLinkProps[] = [];
  items.push({
    to: '/law-portal/dashboard',
    text: formatMessage({ id: 'law-portal.dashboard.menu', defaultMessage: 'Dashboard' }),
    icon: <Dashboard />,
  });

  if (accessToOurLaws) {
    items.push({
      to: '/law-portal/our-laws',
      text: formatMessage({ id: 'law-portal.our-laws.header', defaultMessage: 'Our laws' }),
      icon: <Gavel />,
      subItems: [
        {
          to: '/law-portal/our-laws',
          text: formatMessage({ id: 'law-portal.our-law.tab.law-list' }),
        },
        {
          to: '/law-portal/our-laws/unacknowledged',
          text: formatMessage({ id: 'law-portal.statistics.sub-menu.changes.unacknowledged' }),
        },
        {
          to: '/law-portal/our-laws/acknowledged',
          text: formatMessage({ id: 'law-portal.statistics.sub-menu.changes.acknowledged' }),
        },
      ],
    });
  }
  if (accessToOtherRequirements) {
    items.push({
      to: '/law-portal/other-requirements',
      text: formatMessage({ id: 'law-portal.requirements.header', defaultMessage: 'Other Requirements' }),
      icon: <FormatListBulleted />,
      subItems: [
        {
        text: formatMessage({ id: 'law-portal.requirements.sub-menu.header', defaultMessage: 'List of requirement' }),
        to: `/law-portal/other-requirements`,
      },
      {
        text: formatMessage({ id: 'law-portal.statistics.sub-menu.changes.unacknowledged' }),
        to: `/law-portal/other-requirements/unacknowledged`,
      },
      {
        text: formatMessage({ id: 'law-portal.statistics.sub-menu.changes.acknowledged' }),
        to: `/law-portal/other-requirements/acknowledged`,
      }
      ]
    });
  }
  items.push({
    to: '/law-portal/legal-compliance-control',
    text: formatMessage({ id: 'law-portal.legal.compliance.header', defaultMessage: 'Evaluation control' }),
    icon: <DoneAll />,
    subItems: [
      ...(hasComplianceAdminAccess
        ? [
            {
              text: formatMessage({ id: `law-portal.legal.compliance.sub-menu.planning${menuKeySuffix}` }),
              to: `/law-portal/legal-compliance-control/planning`,
            },
          ]
        : []),
      {
        text: formatMessage({ id: `law-portal.legal.compliance.sub-menu.carry${menuKeySuffix}` }),
        to: `/law-portal/legal-compliance-control/carry`,
      },
      {
        text: formatMessage({ id: `law-portal.legal.compliance.sub-menu.reports${menuKeySuffix}` }),
        to: `/law-portal/legal-compliance-control/reports`,
      },
      ...(!isOldVersion && hasAvvikelserLight
        ? [
            {
              text: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.observations' }),
              to: `/law-portal/legal-compliance-control/observations`,
            },
          ]
        : []),
    ],
  });
  //  items.push({
  //   to:'/law-portal/compliance-control-requirements',
  //   text:formatMessage({id:"law-portal.legal.requirement.header",defaultMessage:'Compliance control requirement'}),
  //   icon:<PlaylistAddCheck/>,
  //  })
  items.push({
    to: '/law-portal/statistics',
    text: formatMessage({ id: 'law-portal.statistics.header', defaultMessage: 'Statistics' }),
    icon: <BarChart />,
    subItems: [
      // {
      //   text: formatMessage({ id: 'law-portal.statistics.sub-menu.compliances.due' }),
      //   to: `/law-portal/statistics/law-compliances/due`,
      // },
      {
        text: formatMessage({ id: 'law-portal.statistics.sub-menu.compliances.done' }),
        to: `/law-portal/statistics/law-compliances`,
      },
      // {
      //   text: formatMessage({ id: 'law-portal.statistics.sub-menu.requirement-compliances.due' }),
      //   to: `/law-portal/statistics/requirement-compliances/due`,
      // },
      {
        text: formatMessage({ id: 'law-portal.statistics.sub-menu.requirement-compliances.done' }),
        to: `/law-portal/statistics/requirement-compliances`,
      },
    ]
  });
  // items.push({
  //   to: '/law-portal/settings',
  //   text: formatMessage({ id: 'law-portal.settings.header', defaultMessage: 'Settings' }),
  //   icon: <Settings />,
  // });
  // items.push({
  //   to: '/law-portal/administration',
  //   text: formatMessage({ id: 'component.home.administration', defaultMessage: 'Administration' }),
  //   icon: <SupervisedUserCircle />,
  // });
  if (hasAccessToModule(Module.Organization) && hasAccessToFeature(OrganizationFeature.Manage, AccessLevel.Administer)) {
    items.push({
      to: '/law-portal/settings',
      activePaths: ['/law-portal/organization'],
      text: formatMessage({ id: 'settings.header', defaultMessage: 'Settings' }),
      icon: <Settings/>,
    });
  }
  items.push({
    to: '/law-portal/help',
    text: formatMessage({ id: 'law-portal.help', defaultMessage: 'Help' }),
    icon: <LiveHelp />,
    externalUrl: 'https://help.lagportalen.se/sv',
  });
  return (
    <Sidebar
      title={formatMessage({ id: 'component.home.law-portal', defaultMessage: 'Lawportal' })}
      items={items}
      sidebarOpen={props.sidebarOpen}
      handleSidebarToggle={props.handleSidebarToggle}
    />
  );
};